import React from 'react';
import ServicesSection from './section_1/Services_Section';
import TestimonialsSection from './section_2/Testimonials_Section';

const Main_Section = () => {
  return (
      <>
        <ServicesSection />
        <TestimonialsSection />
      </>
  )
};

export default Main_Section;
